import { motion } from "framer-motion";
import Reveal, { EASE, Eyebrow } from "./Reveal";

const BANNER_IMG = "https://customer-assets-lqy194kg.emergentagent.net/job_kingdom-reach-media/artifacts/ec6bb2aae7c0278b_space-digital-ministry-banner%20%281%29.png";

export default function LaunchBanner() {
  return (
    <section id="launch" data-testid="launch-banner-section" className="pt-24 pb-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, scale: 0.97, y: 24 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          transition={{ duration: 1, ease: EASE }}
          className="relative rounded-xl overflow-hidden border border-[#C9A83F] shadow-[0_24px_80px_rgba(74,29,107,0.35)]"
          data-testid="launch-banner-image">
          <a href="https://www.masterteacher33.com/donation" target="_blank" rel="noopener noreferrer"
            data-testid="launch-banner-link" className="block group">
            <img src={BANNER_IMG} alt="S.P.A.C.E. Digital Ministry — 90-Day Church Launch, from identity to influence"
              className="w-full h-auto block transition-transform duration-700 group-hover:scale-[1.02]" />
            <span className="absolute inset-0 bg-[#2E1065]/0 transition-colors duration-500 group-hover:bg-[#2E1065]/15" />
            <span className="absolute bottom-4 right-4 rounded-full bg-[#0D2E63] px-5 py-2.5 text-[10px] font-bold tracking-[0.2em] uppercase text-[#F5D76E] opacity-0 transition-all duration-500 group-hover:opacity-100 shadow-lg">
              Enroll Now →
            </span>
          </a>
        </motion.div>

        <Reveal delay={0.15}>
          <div className="mt-14 text-center">
            <Eyebrow>Watch the Introduction</Eyebrow>
            <h2 className="mt-4 font-display text-2xl sm:text-3xl lg:text-4xl uppercase tracking-tight text-[#0D2E63]">
              A Word From Dr. Will Rogers
            </h2>
          </div>
        </Reveal>
        <Reveal delay={0.25}>
          <div className="mt-8 rounded-xl overflow-hidden border border-[#C9A83F] bg-black shadow-[0_24px_80px_rgba(13,46,99,0.25)]"
            data-testid="intro-video-frame">
            <div className="aspect-video">
              <iframe data-testid="intro-video-iframe" className="w-full h-full"
                src="https://www.youtube.com/embed/GiSynJwS1CY?rel=0"
                title="Introduction video from Dr. Willie E. Rogers"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
